/*
 * @Author: flybird
 * @Date: 2021-06-10 11:03:40
 * @LastEditTime: 2021-06-11 10:25:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-project-logic/config/config/pageNote.js
 * key(tableName):value(msg)
 */
export default {
    'OC_B_REFUND_ORDER_EXTRA': `<div style="color:red;line-height: 1;">提示：新增“退货退款”的额外退款单可能因平台重新推单，导致多退，请谨慎操作！</div>`
}
